<template>
  <div :class="{'title': true, 'playModeScale': scaleMode == 'playMode'}">{{ title }}</div>
</template>

<script>
export default {
  props: {
    title: String,
    scaleMode: String
  },
  name: 'Title'
}
</script>

<style lang="scss" scoped>
.title {
  width: auto;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-top: 0.1rem;
  color: #0e776d;
  font-size: 1.3rem;
  font-weight: bold;
  margin-left: 1rem;
  margin-right: 1rem;
  @media (max-width: 800px) {
    font-size: 1.1rem;
  }
  @media (max-width: 500px) {
    font-size: 1rem;
  }
  @media (max-width: 400px) {
    font-size: 0.9rem;
  }
}

.playModeScale {
  @media (max-width: 700px) {
    display: none;
  }
}
</style>